<template>
    <div class="match-info">
      <div>
        <div class="head">基本信息</div>
        <div class="content">
            <div>
                时间：<span>{{ filterDate(match.beginDate,'yyyy/MM/DD') }}</span> — <span>{{ filterDate(match.endDate,'yyyy/MM/DD') }}</span>
            </div>
            <div>
                地址：<span>{{ match.city && match.city.name }}{{ match.district && match.district.name }}</span>
            </div>
            <div class="multi-block">
                <div style="position: absolute">场馆：</div>
                <div style="margin-left: 42px" v-for="location,i in locations" :key="i">{{ location }}</div>
            </div>
        </div>
      </div>
      <div>
        <div class="head">比赛赛制</div>
        <div class="content" >
            <div>
                <span>{{ match.teamCount }}队</span>&nbsp;&nbsp;&nbsp;
                <span>{{ match.type=='league'?'联赛':'杯赛' }}</span>
            </div>
            <div>
                <span>{{ match.gameType }}</span>&nbsp;&nbsp;&nbsp;
                <span>{{ match.ruleType }}</span>
            </div>
            <div v-if="match.type === 'league'">
                比赛：<span>{{ match.roundCount }}轮</span>
            </div>
            <div v-if="match.type === 'cup'">
                小组赛：<span>{{ match.roundCount }}轮</span>
            </div>
            <div v-if="match.type === 'cup'">
                淘汰赛：<span>{{ match.knockoutRoundCount }}轮</span>
            </div>
            <div>
                同分：<span>{{ teamScoreOrderRule(match.teamScoreOrderRule) }}</span>
            </div>
        </div>
      </div>
      <div v-if="shouldShowRule">
        <div class="head">规则设定</div>
        <div class="content" v-if="sportTypes === '足球'" >
            <div v-if="matchInfo.spikeRuleEnabled">
                鞋钉要求：<span v-for="option in matchInfo.spikeOptions" :key="option.id"><span v-if="option.selected">{{option.shortName}}&nbsp;&nbsp;&nbsp;</span></span>
            </div>
            <div v-if="matchInfo.substitutionPlayerCountLimitEnabled">
                换人规则：<span>允许换人人数{{ matchInfo.substitutionPlayerCountLimit }}个</span>
            </div>
            <div v-if="matchInfo.substitutionTotalCountLimitEnabled">
                换人规则：<span>允许换人次数{{ matchInfo.substitutionTotalCountLimit }}次</span>
            </div>
            <div v-if="matchInfo.legGuardRequired || !matchInfo.metalWearAllowed">
                其他装备：<span v-if="match.legGuardRequired">佩戴护腿板&nbsp;&nbsp;&nbsp;</span><span v-if="!matchInfo.metalWearAllowed">禁止金属饰品</span>
            </div>
            <div>
                <span v-if="matchInfo.semiDuration>0">半场时间：{{matchInfo.semiDuration}} 分钟&nbsp;&nbsp;&nbsp;</span><span v-if="matchInfo.halfTimeDuration>0">中场休息：{{matchInfo.halfTimeDuration}} 分钟</span>
            </div>
        </div>
        <div class="content" v-if="sportTypes === '篮球'" >
            <div>
                节数：<span><span v-if="matchInfo.sections > 0" > {{matchInfo.sections}}节、</span> <span v-if=" matchInfo.sectionTime > 0" >每节{{matchInfo.sectionTime}}分钟</span></span>
            </div>
            <div>
                暂停次数：<span><span v-if="matchInfo.pauseLimit > 0" >{{matchInfo.pauseLimit}}次、</span> <span v-if="matchInfo.pauseTime > 0" >{{matchInfo.pauseTime}}分钟</span> </span>
            </div>
            <div>
                加时时间：<span v-if="matchInfo.overTime > 0" >{{matchInfo.overTime}}分钟</span>
            </div>
            <div>
                允许犯规次数：<span v-if="matchInfo.foulsLimit > 0" >{{matchInfo.foulsLimit}}次</span>
            </div>
            <div>
                休息时间：<span v-if="matchInfo.halfTimeDuration > 0" >{{matchInfo.halfTimeDuration}}分钟</span>
            </div>
        </div>
        <div class="content" v-if="sportTypes == '乒乓球' || sportTypes == '羽毛球'" >
          <div>
              局数：<span><span v-if="matchInfo.sections > 0" > {{ matchInfo.sections }}节</span></span>
          </div>
          <div>
              暂停次数：<span><span v-if="matchInfo.pauseLimit > 0" >{{ matchInfo.pauseLimit }}次、</span> <span v-if="matchInfo.pauseTime > 0" >{{ matchInfo.pauseTime }}分钟</span> </span>
          </div>
        </div>
        <div class="content" v-if="sportTypes == '冰球'" >
            <div>
                局数：<span v-if="matchInfo.sections" >{{ matchInfo.sections }}局</span>
            </div>
            <div>
                每局时常：<span v-if="matchInfo.sectionTime" >{{ matchInfo.sectionTime }}分钟</span>
            </div>
            <div>
                场赛总时常：<span v-if="matchInfo.duration" >{{ matchInfo.duration }}分钟</span>
            </div>
            <div>
                局间休息时常：<span v-if="matchInfo.halfTimeDuration" >{{ matchInfo.halfTimeDuration }}分钟</span>
            </div>
            <div>
                加时赛时常：<span v-if="matchInfo.overTime" >{{ matchInfo.overTime }}分钟</span>
            </div>
        </div>
      </div>
      <div v-if="shouldShowSignup">
        <div class="head">报名须知</div>
        <div class="content">
            <div v-if="match.teamMemberLimitCount>0">
                报名人数：<span>{{ match.teamMemberLimitCount }}</span>
            </div>
            <div class="multi-block" v-if="signupFields">
                <div style="position: absolute">报名资料：</div>
                <div style="margin-left: 70px">{{ signupFields }}</div>
            </div>
            <div v-if="match.allowTeamSignup && match.regEndDate">
                截止日期：<span>{{ filterDate(match.regEndDate,'yyyy-MM-DD') }}</span>
            </div>
            <div v-if="match.entryFee>-1">
                报名费用：<span>{{ match.entryFee }}元/队</span>
            </div>
            <div v-if="match.deposit>-1">
                纪律保证金：<span>{{ match.deposit }}元/队</span>
            </div>
        </div>
      </div>
      <div v-if="match.awards">
        <div class="head">奖励说明</div>
        <div class="content">
            <div style="white-space: pre-line;" v-for="award in awards" :key="award.id" v-html="award"></div>
        </div>
      </div>
      <div v-if="shouldShowOrganizer">
        <div class="head">组委信息</div>
        <div class="content">
            <div class="multi-block" v-if="match.supervisor">
                <div style="position: absolute">指导单位：</div>
                <div style="margin-left: 70px" v-for="supervisor,i in supervisors" :key="i">{{ supervisor }}</div>
            </div>
            <div class="multi-block" v-if="match.endorser">
                <div style="position: absolute">主办方：</div>
                <div style="margin-left: 56px" v-for="endorser,i in endorsers" :key="i">{{ endorser }}</div>
            </div>
            <div class="multi-block" v-if="match.contactor">
                <div style="position: absolute">承办方：</div>
                <div style="margin-left: 56px" v-for="contactor,i in contactors" :key="i">{{ contactor }}</div>
            </div>
            <div class="multi-block" v-if="match.coorganizer">
                <div style="position: absolute">协办方：</div>
                <div style="margin-left: 56px" v-for="coorganizer,i in coorganizers" :key="i">{{ coorganizer }}</div>
            </div>
        </div>
      </div>
      <div v-if="description">
        <div class="head">赛事简介</div>
        <div class="content" v-html="description"></div>
      </div>
      <div class="head" v-if="docs.length>0">其他信息</div>
      <table>
        <tr v-for="doc in docs" :key="doc.id" @click="goDocument(doc)">
            <td>{{ doc.title }}</td>
            <td><img class="pull-right list-arrow" src="@/assets/images/list_arrow.png" alt=""></td>
        </tr>
      </table>
    </div>
</template>

<script>
import { getBMMatchDetail } from '@/api/match'
import Moment from 'moment'
export default {
  data() {
    return {
      matchId: null,
      match: {},
      matchInfo: {},
      locations: [],
      sportTypes: '',
      shouldShowRule: null,
      shouldShowSignup: null,
      signupFields: null,
      awards: [],
      shouldShowOrganizer: null,
      description: null,
      docs: [],
      supervisors: [],
      endorsers: [],
      contactors: [],
      coorganizers: []
    }
  },
  mounted() {
    this.matchId = this.$route.query.matchId
    this.getBMMatchDetail()
  },
  methods: {
    getBMMatchDetail() {
      getBMMatchDetail({ matchId: this.matchId }).then(res => {
        const data = res.data
        const match = data.match
        this.sportTypes = data.match.sportType
        this.match = match
        this.matchInfo = match
        const fieldsMap = {
          bmTrueName: '姓名',
          number: '球衣号码',
          gender: '性别',
          bmEmail: '邮箱',
          isPhotoPass: '大头证件照',
          IDCardNumber: '身份证号码',
          contactNumber: '手机号码',
          isIDCardPhotoPass: '身份证照片',
          bmBirthday: '出生年月',
          high: '身高',
          weight: '体重',
          clothesSize: '球衣尺码'
        }
        if (match.signupFields) {
          this.signupFields = match.signupFields.split(',').reduce(function(previous, current) {
            return previous + '，' + fieldsMap[current]
          }, '').replace('，', '')
          if (match.remarkDisplayName) {
            this.signupFields = this.signupFields + '，' + match.remarkDisplayName
          }
          if (match.remarkDisplayName1) {
            this.signupFields = this.signupFields + '，' + match.remarkDisplayName1
          }
          if (match.remarkDisplayName2) {
            this.signupFields = this.signupFields + '，' + match.remarkDisplayName2
          }
        }
        this.awards = match.awards.replace(/｜/g, '|').split('|')
        this.supervisors = match.supervisor.replace(/｜/g, '|').split('|')
        this.endorsers = match.endorser.replace(/｜/g, '|').split('|')
        this.contactors = match.contactor.replace(/｜/g, '|').split('|')
        this.coorganizers = match.coorganizer.replace(/｜/g, '|').split('|')
        this.locations = data.match.locations ? data.match.locations.split(',') : ''
        this.description = match.description.replace(/\n/g, '<br>')
        this.shouldShowOrganizer = (match.endorser || match.contactor || match.coorganizer || match.supervisor)
        this.shouldShowRule = (match.spikeRuleEnabled || match.substitutionRuleEnabled || match.legGuardRequired || !match.metalWearAllowed || match.semiDuration > 0 || match.halfTimeDuration > 0)
        this.shouldShowSignup = (match.teamMemberLimitCount > 0 || (match.allowTeamSignup && match.regEndDate) || match.entryFee > -1 || match.deposit > -1 || this.signupFields)
        this.docs = data.regulations.documentList
      })
    },
    teamScoreOrderRule(index) {
      return ['胜负关系优先', '净胜球优先', '红黄牌优先'][index]
    },
    filterDate(date, type) {
      return Moment(date).format(type)
    },
    goDocument(doc) {
      this.$router.push({ path: '/doc-detail', query: { documentId: doc.id }})
    }
  }
}
</script>

<style scoped lang="scss">
.match-info{
  font-size: 14px;
  background-color: #F2F2F2;
  .head {
    padding: 15px 0 5px 15px;
    font-size: 12px;
    color: #ababab;
  }
  .content {
    padding: 15px;
    line-height: 24px;
    background-color: #fff;
  }
  table{
    width: 100%;
    border-collapse: collapse;
  }
  tr{
    border-bottom: 1px solid #f0f0f0;
    background-color: #fff;
    td{
      padding: 15px;
      .list-arrow {
          height: 18px;
          width: auto;
          float: right!important;
      }
    }
  }
}
</style>
